import { render, staticRenderFns } from "./CommonFormWithMaterialEditor.vue?vue&type=template&id=3472c302&lang=pug&"
import script from "./CommonFormWithMaterialEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithMaterialEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithMaterialEditor.vue?vue&type=style&index=0&id=3472c302&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports